export default __webpack_public_path__ + "images/f6e9e3e2bfdd5f4293368a2a5e00f96d.png";